var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.722656 19.985C0.722656 9.11572 9.53421 0.304138 20.4035 0.304138C31.2678 0.316284 40.0723 9.12085 40.0844 19.985C40.0844 30.8544 31.2729 39.666 20.4035 39.666C9.53421 39.666 0.722656 30.8544 0.722656 19.985ZM30.6548 27.989V21.2222C30.6548 17.9118 29.9421 15.3617 26.0721 15.3617C24.2116 15.3617 22.9631 16.3827 22.4534 17.3506H22.3996V15.6708H18.7302V27.989H22.551V21.8895C22.551 20.2835 22.8554 18.7306 24.8443 18.7306C26.8039 18.7306 26.8332 20.5633 26.8332 21.9925V27.9898L30.6548 27.989ZM16.334 15.6717H12.5085V27.9899H16.334V15.6717ZM14.4196 9.539C13.1964 9.539 12.204 10.5315 12.204 11.7546C12.204 12.9778 13.1964 13.991 14.4196 13.991C15.6428 13.991 16.6352 12.9778 16.6352 11.7546C16.6345 10.5315 15.6419 9.539 14.4196 9.539Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcLinkedin);
export default __webpack_public_path__ + "static/media/h_ic_linkedin.dc69e468.svg";
export { ForwardRef as ReactComponent };